import React, { useRef, useState } from 'react';
import * as styled from './HomeworkImageUploader.styled';
import axios from '../../axios';
import { compressImage } from '../../helpers/compressImage';

const HomeworkImageUploader = ({ images = [], onImagesChange, lessonId, onUploadingChange }) => {
  const fileInputRef = useRef(null);
  const [uploading, setUploadingState] = useState(false);
  const setUploading = (value) => {
    setUploadingState(value);
    onUploadingChange?.(value);
  };

  const handleImageUpload = async (event) => {
    const files = Array.from(event.target.files);

    // 🔸 Проверка на общее количество
    if (images.length + files.length > 2) {
      alert('Максимум 2 фотографії дозволено.');
      event.target.value = '';
      return;
    }

    try {
      setUploading(true);

      // 🔸 Сжимаем фото с телефона, потом проверяем размер
      const compressed = await Promise.all(files.map(compressImage));
      const validFiles = compressed.filter(file => file.size <= 5 * 1024 * 1024);
      if (validFiles.length !== compressed.length) {
        alert('Деякі файли занадто великі. Максимальний розмір - 5MB.');
      }
      if (validFiles.length === 0) return;

      // 📨 Загружаем на сервер
      const formData = new FormData();
      validFiles.forEach(file => formData.append('images', file));

      const { data } = await axios.post('/homework/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      // data.urls → массив URL с сервера
      onImagesChange(prev => [...prev, ...data.urls]);
    } catch (error) {
      console.error('Помилка завантаження файлів:', error);
      alert('Не вдалося завантажити зображення. Спробуйте ще раз.');
    } finally {
      setUploading(false);
      event.target.value = '';
    }
  };

  // 🗑 Удаление
  const removeImageFromServer = async (lessonId, imgIndex) => {
    try {
      await axios.delete(`marked-lessons/remove-image/${lessonId}`, {
        data: { imgIndex }
      });
    } catch (error) {
      console.error('Error removing image from server:', error);
    }
  };

  const removeImage = async (index) => {
    const newImages = images.filter((_, i) => i !== index);
    onImagesChange(newImages);

    if (lessonId) {
      await removeImageFromServer(lessonId, index);
    }
  };

  const handleAddClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <styled.ImageUploaderWrapper>
      <styled.ImageGrid>
        {images.map((image, index) => (
          <styled.ImagePreview key={index}>
            <img src={image} alt={`Homework ${index + 1}`} />
            <styled.RemoveButton onClick={() => removeImage(index)}>
              ×
            </styled.RemoveButton>
          </styled.ImagePreview>
        ))}

        <styled.AddImageButton onClick={handleAddClick}>
          {uploading ? (
            <p>Завантаження...</p>
          ) : (
            <>
              <span>+</span>
              <p>Додати фото</p>
            </>
          )}
        </styled.AddImageButton>
      </styled.ImageGrid>

      <styled.HiddenInput
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        onChange={handleImageUpload}
      />

      <styled.InfoText>
        Максимальний розмір фотографій: 5MB. Максимум 2 фотографії
      </styled.InfoText>
    </styled.ImageUploaderWrapper>
  );
};

export default HomeworkImageUploader;
